import { Button } from "@mui/material";
import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { HorizontalGap } from "../styled/gaps";

const ActionButton = (props) => {
  return (
    <Button
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      variant="outlined"
      onClick={props.clickHandler}
    >
      <AddCircleOutlineIcon /> <HorizontalGap size={"5px"} />{" "}
      <span>{props.label}</span>
    </Button>
  );
};

export { ActionButton };
